(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('account.clover', {
                parent: 'account',
                url: '/clover??merchant_id&employee_id&client_id&code',
                data: {
                    authorities: [],
                    specialClass: " gray-bg"
                },
                views: {
                    'layout@': {
                        templateUrl: 'app/layouts/clover_layout.html'
                    },
                    'content@account.clover': {
                        templateUrl: 'app/account/clover/clover.html',
                        controller: 'CloverController',
                        controllerAs: 'vm'
                    },
                    'navbar@app': {},
                    'topnavbar@app': {},
                    //'footer@app': {
                    //    templateUrl: 'app/layouts/footer/footer.html'
                    //}

                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('account.clover');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
